<cam-panel-form-layout
  [askValidation$]="this.askValidation$"
  [formValidity]="this.formValidity"
  [parentRequestState]="this.requestState"
  class="full-width"
>
  <div class="d-flex flex-column m-space-md">
    <cam-menu-navigation [menu]="this.selectionCreation" container="tags"></cam-menu-navigation>
    @if (this.filterHelper.filter === this.ECalendarMenuKey.visits) {
      <cam-visit-event-form
        [data]="this.data()"
        [formService]="this.formService()"
        [askValidation]="this.askValidation$"
        [loader]="this.requestState.isLoading()"
        [error]="{ status: this.requestState.getErrorStatus(), message: this.requestState.getErrorMessage() }"
        (isFormValid)="this.formValidity.set($event)"
        (added)="this.askClose.emit(null)"
      ></cam-visit-event-form>
    } @else if (this.filterHelper.filter === this.ECalendarMenuKey.notes) {
      <cam-create-note-form
        [data]="this.data()"
        [askValidation]="this.askValidation$"
        [loader]="this.requestState.isLoading()"
        [error]="{ status: this.requestState.getErrorStatus(), message: this.requestState.getErrorMessage() }"
        (isFormValid)="this.formValidity.set($event)"
        (added)="this.askClose.emit(null)"
      ></cam-create-note-form>
    } @else if (this.filterHelper.filter === this.ECalendarMenuKey.unavailabilities) {
      <cam-create-unavailability-form
        [data]="this.data()"
        [askValidation]="this.askValidation$"
        [loader]="this.requestState.isLoading()"
        [error]="{ status: this.requestState.getErrorStatus(), message: this.requestState.getErrorMessage() }"
        (isFormValid)="this.formValidity.set($event)"
        (added)="this.askClose.emit(null)"
      ></cam-create-unavailability-form>
    }</div
></cam-panel-form-layout>
